<template>
    <div>
        <modal :name="modal_name" class="final-modal z-placement-custom add-costing" transition="nice-modal-fade" style="z-index: 9999 !important">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header" style="background:#f0ddb7 !important;">
                    <span class="v-modal-dialog-title v-modal-title text-black" style="text-transform:none !important;">Save Filter</span>
                </div>
                <div class="general-section pt-2 pl-0 pr-0 pb-1" style="background-color:white;border-radius:0px">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 410px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div class="add-filter mb-3">
                                <div class="mt-5 w-50">
                                    <label class="inputLabel fs-14 fw-600 text-black">Filter Name </label>
                                    <span class="d-flex">
                                        <input v-validate="'required'" v-model="filterName" name="filter_name" class="inputFieldCost" type="text" placeholder="Enter Name" />
                                    </span>
                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('filter_name')">Name is Required</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <a class="btn btn-danger-new mr-0" style="text-transform: uppercase !important;font-size: 12px !important;" @click="cancel()">Cancel</a>
                        <button type="button" class="btn btn-green ml-4" @click="save()" style="box-shadow: none;">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';
export default {
    props:['modal_name'],
    components:{
        SweetModal
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            filterName:''
        }
    },
    methods:{
        cancel(){
            this.$modal.hide(this.modal_name);
            this.filterName = ''
        },
        save(){
            this.$validator.validateAll().then(result => {
                if (result == true) {
                    this.$emit('filterSaved',this.filterName)
                    this.cancel();
                    this.$modal.hide(this.modal_name);
                }
            })
        },
    }
}
</script>
<style scoped>
  .add-filter .inputFieldCost {
	font-size: 14px !important;
	padding: 10px 11px 7px 8px !important;
	display: block;
	width: 100%;
	border: solid 1px #005dae !important;
	background: #ffffff !important;
	color: #303031;
	font-weight: 600;
  border-radius: 5px;
	margin-top: 5px;
}
    .add-filter{
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
   }
.add-filter .inputFieldCost:focus {
	outline: none;
}
</style>
